import { ReduxService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';

import { basicSettingsActions } from 'actions/settings';
import { ExcelUtils } from 'utils';

export const settingsInitialState = {
  columns: [],
  excelSeriesOptimalization: true,
  company: undefined,
  definedTime: TimeService.UTC,
  definedNumberFormat: ExcelUtils.numberFormatTypesObj.GENERAL,
  userName: undefined,
  seriesResultsColumns: [],

  uiEntitlements: {}
}

export default (state = settingsInitialState, action) => {
  switch (action.type) {
    case basicSettingsActions.ON_CHANGE:
      return ReduxService.updateObject(state, { [action.name]: action.value })
    default:
      return state;
  }
}
